module.exports = __webpack_public_path__ + "img/crop_info_left_feet.80903e8d.gif";